import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {DataPatchingRecallService} from './data-patching-recall.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CustomerSharedService } from '../../customer-shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { measure } from 'ng-zorro-antd/core/util';
import { CommonService } from '../../../../shared/services/common.service';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  activeForm: 'patching' | 'recall' | null = null;
  isConfirmLoading = false;
  isLoading: boolean = false;
  isVisible: boolean = false;

  patchingForm!: FormGroup;
  recallForm!: FormGroup;

  customer_id: string = '';
  devices: any = [];

  constructor(
    public customerSharedService: CustomerSharedService,
    public commonService: CommonService,
    public route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataPatchingRecallService: DataPatchingRecallService,
    private msg: NzMessageService,
    private modal: NzModalService
  ) {
    this.customer_id = this.route.snapshot.paramMap.get('id') || '';
  }

  ngOnInit() {
    this.initializePatchingForm();
    this.initializeRecallForm();
    this.getAllSensors();
  }

  toggleForm(formType: 'patching' | 'recall') {
    if (this.activeForm === formType) {
      this.closeForm();
    } else {
      this.activeForm = formType;
      // Reset the form when switching
      if (formType === 'patching') {
        this.patchingForm.reset();
      } else {
        this.recallForm.reset();
      }
    }
  }

  closeForm() {
    this.activeForm = null;
    this.patchingForm.reset();
    this.recallForm.reset();
  }

  initializePatchingForm() {
    this.patchingForm = this.fb.group({
      measurement: ['', [Validators.required]],
      field: ['', [Validators.required]],
      deviceeui: [null, [Validators.required]],
      date_range: ['', [Validators.required]],
    });
  }

  initializeRecallForm() {
    this.recallForm = this.fb.group({
      deviceEui: ['', [Validators.required]],
      date_range: ['', [Validators.required]],
    });
  }

  missingReportsForm() {
    this.router.navigate([`/missingReportsForm/${this.customer_id}`]); // Fixed backtick placement
  }

  onPatchingFormSubmit(){
    this.isConfirmLoading = true;
    const data = this.patchingForm.value;
    const startdate = data.date_range[0];
    const enddate = data.date_range[1];
    const startDateUTC = new Date(startdate).toISOString();
    const endDateUTC = new Date(enddate).toISOString();
    console.log('Patching Form Data:', data);
    this.dataPatchingRecallService.dataPatching(data).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        if (response?.status === 200) {
          this.commonService.message.success(
            'Data Patched Successfully'
          );
          this.closeForm();
        } else {
          this.commonService.message.error(
            response?.message || ('Failed to Patch Data')
          );
        }
        this.isConfirmLoading = false;
      },
      error: (error: any) => {
        this.commonService.message.error(
          'An error occurred while patching the data'
        );
        console.error('Error:', error);
        this.isConfirmLoading = false;
      }
    });
  }

  getAllSensors(){
    this.dataPatchingRecallService.getAllSensors().pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        this.devices = response?.result.map((item: any) => item.device_ui);
      },
      error: (error: any) => {
        console.error('Error:', error);
      }
    });
  }

  onRecallFormSubmit()
  {
    this.isConfirmLoading = true;
    const data = this.recallForm.value;
    const startdate = data.date_range[0];
    const enddate = data.date_range[1];
    // Convert to UTC
    const startDateUTC = new Date(startdate).toISOString();
    const endDateUTC = new Date(enddate).toISOString();
    data.date_range = [startDateUTC, endDateUTC];
    console.log('Recall Form Data:', data);

    this.dataPatchingRecallService.dataRecall(data).pipe(untilDestroyed(this)).subscribe({
      next: (response: any) => {
        if (response?.status === 200) {
          this.commonService.message.success(
            'Data Recalled Successfully'
          );
          this.closeForm();
        } else {
          this.commonService.message.error(
            response?.message || ('Failed to Recall Data')
          );
        }
        this.isConfirmLoading = false;
      },
      error: (error: any) => {
        this.commonService.message.error(
          'An error occurred while data recall'
        );
        console.error('Error:', error);
        this.isConfirmLoading = false;
      }
    });
  }
}
